import { getUchiLoginRedirectUrl } from './getUchiLoginRedirectUrl';

export const goToUchiLoginAndRedirect = (url: string) => {
  const redirectUrl = getUchiLoginRedirectUrl(url);

  window.location.assign(redirectUrl);
};
